import React, { createContext, useReducer, useEffect } from "react";
import axios from "axios";
import { productReducer, initialState } from '../reducer/productReducer';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const [state, dispatch] = useReducer(productReducer, initialState);

    const AllProducts = async () => {
        dispatch({ type: "FETCH_START" });
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-all-products`);
            dispatch({ type: "FETCH_SUCCESS", payload: res.data.data });
        } catch (err) {
            dispatch({ type: "FETCH_ERROR", payload: err.response?.data?.message || "Failed to fetch products" });
        }
    };

    useEffect(() => {
        AllProducts();
    }, []);

    return (
        <ProductContext.Provider value={{ ...state, AllProducts }}>
            {children}
        </ProductContext.Provider>
    );
};
